// devices
const CAMERA = 'camera'
const MICROPHONE = 'microphone'

// common states
const INITIAL = 'initial'
const GRANTED = 'granted'
const ERROR = 'error'

// device permission states
const NOT_GRANTED = 'not granted'
const DENIED = 'Permission denied'
const DISMISSED = 'Permission dismissed' // Chrome default permission dismissed message
const NOT_SUPPORTED = 'not supported'

// local tracks states
const OBTAINED = 'obtained'

// selected devices actions
const SET_VIDEO_INPUT = 'SET_VIDEO_INPUT'
const SET_AUDIO_INPUT = 'SET_AUDIO_INPUT'
const SET_AUDIO_OUTPUT = 'SET_AUDIO_OUTPUT'
const SET_VIDEO_INPUTS = 'SET_VIDEO_INPUTS'
const SET_AUDIO_INPUTS = 'SET_AUDIO_INPUTS'
const SET_AUDIO_OUTPUTS = 'SET_AUDIO_OUTPUTS'
const SET_DEVICES = 'SET_DEVICES'

// device types
const TYPES = {
  VIDEO_INPUT: 'videoinput',
  AUDIO_INPUT: 'audioinput',
  AUDIO_OUTPUT: 'audiooutput',
}

const TRACK_KINDS = {
  AUDIO: 'audio',
  VIDEO: 'video',
}

const HELP_LINK = 'https://support.teleport.co/problem-connecting-devices'

export {
  CAMERA,
  MICROPHONE,
  INITIAL,
  GRANTED,
  ERROR,
  NOT_GRANTED,
  DENIED,
  DISMISSED,
  OBTAINED,
  NOT_SUPPORTED,
  SET_VIDEO_INPUT,
  SET_AUDIO_INPUT,
  SET_AUDIO_OUTPUT,
  SET_VIDEO_INPUTS,
  SET_AUDIO_INPUTS,
  SET_AUDIO_OUTPUTS,
  SET_DEVICES,
  TYPES,
  HELP_LINK,
  TRACK_KINDS,
}
